import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';
import { Map as ImmutableMap } from 'immutable';

export const CHAT_DISCLAIMER = 'CHAT_DISCLAIMER';

export const closeChatDisclaimer = () => {
  store?.dispatch(rootUiActions.removeDialog(CHAT_DISCLAIMER));
};

const useChatDisclaimer = () => {
  return (props?: { continue?: () => void }) => {
    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: CHAT_DISCLAIMER,
          type: CHAT_DISCLAIMER,
          props: ImmutableMap({ ...props, onClose: closeChatDisclaimer }),
        }),
      ),
    );
  };
};

export default useChatDisclaimer;
